/** Step definitions for in-page spotlight tutorials (i18n keys under pageTutorial.*). */

const WELCOME = { type: 'welcome' };

export const TUTORIAL_GUIDE_CONFIG = {
  jupas: [
    { ...WELCOME, titleKey: 'pageTutorial.jupas.welcomeTitle', bodyKey: 'pageTutorial.jupas.welcomeBody' },
    { anchor: 'search', placement: 'top', scrollIntoView: false, anchorSettleMs: 600, titleKey: 'pageTutorial.jupas.searchTitle', bodyKey: 'pageTutorial.jupas.searchBody' },
    { anchor: 'ordering', placement: 'top', scrollIntoView: false, anchorSettleMs: 600, titleKey: 'pageTutorial.jupas.orderingTitle', bodyKey: 'pageTutorial.jupas.orderingBody' }
  ],
  report: [
    { ...WELCOME, titleKey: 'pageTutorial.report.welcomeTitle', bodyKey: 'pageTutorial.report.welcomeBody' },
    { anchor: 'profile', placement: 'bottom', titleKey: 'pageTutorial.report.profileTitle', bodyKey: 'pageTutorial.report.profileBody' },
    { anchor: 'results', placement: 'top', titleKey: 'pageTutorial.report.resultsTitle', bodyKey: 'pageTutorial.report.resultsBody' },
    { anchor: 'jupas', placement: 'top', titleKey: 'pageTutorial.report.jupasTitle', bodyKey: 'pageTutorial.report.jupasBody' }
  ],
  ability: [
    { ...WELCOME, titleKey: 'test.guideWelcomeTitle', bodyKey: 'test.guideWelcomeBody' },
    { anchor: 'progress', placement: 'bottom', titleKey: 'test.guideProgressTitle', bodyKey: 'test.guideProgressBody' },
    { anchor: 'grid', placement: 'top', titleKey: 'test.guidePapersTitle', bodyKey: 'test.guidePapersBody' },
    { anchor: 'firstTile', placement: 'right', titleKey: 'test.guideTileTitle', bodyKey: 'test.guideTileBody' }
  ],
  eddy: [
    { ...WELCOME, titleKey: 'pageTutorial.eddy.welcomeTitle', bodyKey: 'pageTutorial.eddy.welcomeBody' },
    { anchor: 'chat', placement: 'top', titleKey: 'pageTutorial.eddy.chatTitle', bodyKey: 'pageTutorial.eddy.chatBody' },
    { anchor: 'input', placement: 'top', titleKey: 'pageTutorial.eddy.inputTitle', bodyKey: 'pageTutorial.eddy.inputBody' },
    { anchor: 'tools', placement: 'top', titleKey: 'pageTutorial.eddy.toolsTitle', bodyKey: 'pageTutorial.eddy.toolsBody' }
  ],
  trajectory: [
    { ...WELCOME, titleKey: 'pageTutorial.trajectory.welcomeTitle', bodyKey: 'pageTutorial.trajectory.welcomeBody' },
    { anchor: 'sidebar', placement: 'right', titleKey: 'pageTutorial.trajectory.sidebarTitle', bodyKey: 'pageTutorial.trajectory.sidebarBody' },
    { anchor: 'map', placement: 'bottom', titleKey: 'pageTutorial.trajectory.mapTitle', bodyKey: 'pageTutorial.trajectory.mapBody' },
    { anchor: 'sidebar', placement: 'right', titleKey: 'pageTutorial.trajectory.saveTitle', bodyKey: 'pageTutorial.trajectory.saveBody' }
  ],
  interest: [
    { ...WELCOME, titleKey: 'pageTutorial.interest.welcomeTitle', bodyKey: 'pageTutorial.interest.welcomeBody' },
    { anchor: 'session', placement: 'bottom', titleKey: 'pageTutorial.interest.sessionTitle', bodyKey: 'pageTutorial.interest.sessionBody' },
    { anchor: 'stats', placement: 'top', titleKey: 'pageTutorial.interest.statsTitle', bodyKey: 'pageTutorial.interest.statsBody' },
    { anchor: 'stats', placement: 'top', titleKey: 'pageTutorial.interest.tiersTitle', bodyKey: 'pageTutorial.interest.tiersBody' }
  ]
};

/**
 * @param {string} sessionId
 * @param {(key: string) => string} t
 */
export function resolveTutorialGuideSteps(sessionId, t) {
  const config = TUTORIAL_GUIDE_CONFIG[sessionId];
  if (!config) return [];
  return config.map((step) => ({
    type: step.type,
    anchor: step.anchor,
    placement: step.placement,
    scrollBlock: step.scrollBlock,
    scrollIntoView: step.scrollIntoView,
    showHighlight: step.showHighlight,
    anchorSettleMs: step.anchorSettleMs,
    title: t(step.titleKey),
    body: t(step.bodyKey)
  }));
}
